import { useState, useEffect } from "react";
import axios from "../utils/api";

/**
 * What the app charges, asked once and shared.
 *
 * The price used to be written into three components by hand, and two of them
 * disagreed — the trial banner offered $3/mo while the subscription panel said
 * $9.99. Anyone who saw both had a reason to doubt the rest of the product, so
 * the number now comes from the server, which reads the live Stripe coupon.
 *
 * Starts from the list price rather than null so nothing renders a blank or a
 * spinner where a price belongs; the launch offer appears a moment later if
 * one is running.
 */
const FALLBACK = { listPrice: 9.99, currency: "usd", launchActive: false, launchPrice: null, percentOff: null };

export function usePricing() {
  const [pricing, setPricing] = useState(FALLBACK);

  useEffect(() => {
    let cancelled = false;
    axios.get("/api/billing/pricing")
      .then((res) => { if (!cancelled && res.data) setPricing({ ...FALLBACK, ...res.data }); })
      .catch(() => { /* keep the list price — never show a blank where money goes */ });
    return () => { cancelled = true; };
  }, []);

  /** The amount actually charged today. */
  const effectivePrice = pricing.launchActive && pricing.launchPrice != null
    ? pricing.launchPrice
    : pricing.listPrice;

  const fmt = (v) => `$${Number(v).toFixed(2)}`;

  return {
    ...pricing,
    effectivePrice,
    /** "$2.99" — what they pay now. */
    effectiveLabel: fmt(effectivePrice),
    /** "$9.99" — the list price, shown struck through while an offer runs. */
    listLabel: fmt(pricing.listPrice),
  };
}
